import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ErrorHandlerActions = createActionGroup({
  source: 'Error Handler',
  events: {
    'Throw Error': props<{ error: HttpErrorResponse }>(),
    'Clear Error': emptyProps(),
  },
});
